import assert from 'assert';
import { isNil, pathOr, isEmpty } from 'ramda';
import { HttpUnauthorized, HttpHone } from './httpError';
const fetch = require('node-fetch');

export const request = async (body, refreshToken = false, token) => {
  const response = await fetch(token ? '/files/late-edit/upload' : '/files/upload', {
    method: 'POST',
    body,
    ...(token ? { headers: { token } } : {})
  });

  if (response.status === 200) return response;

  if (response.status === 401) {
    assert(!refreshToken, 'can not refresh access token');
    throw new HttpUnauthorized('Accès non autorisé');
  }

  // Aucun document
  if (response.status === 410) {
    throw new HttpHone('Aucune resource disponible');
  }

  throw new Error(`request failed (${response.status})`);
};

export const upload = async (body, token) => {
  const response = await request(body, false, token);
  if (response.status === 200) {
    const json = await response.json();
    const { errors } = json;

    if (isNil(errors) || isEmpty(errors)) return json;
    throw Error(pathOr('request failed', [0, 'message'])(errors));
  }
};
